module.exports = __webpack_public_path__ + "img/Villa_Borna_2.29ed1e2d.jpg";